enum View {
    Slides,
    Settings,
}
export default View;
